import {
  HttpErrorResponse,
  HttpInterceptorFn,
  HttpStatusCode,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { MessageService } from 'primeng/api';
import { catchError, of, throwError } from 'rxjs';
import { StatusInfo } from '../models';
import { AuthService } from '../services';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const messageService = inject(MessageService);
  const authService = inject(AuthService);
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      let errorBody = error.error;
      let msg = error.message;
      let statusMsg = '';
      if (
        errorBody &&
        errorBody['statusList'] &&
        Array.isArray(errorBody['statusList'])
      ) {
        const errorStatusList = errorBody['statusList'] as Array<StatusInfo>;

        for (let info of errorStatusList) {
          if (info.error) {
            statusMsg += info.desc + ';';
          }
        }
        msg = statusMsg;
      }

      // 401 = 会话已失效,只做本地清理(过期提示由 AuthService.sessionExpired$ 统一弹一次)。
      // 不能调 logOut():后端 logout 也会 401,会被这里再次拦到,形成反复调用 logout 的循环。
      // 登录失败也是 401,这里不弹 toast,由登录页自己显示错误。
      if (error.status == HttpStatusCode.Unauthorized) {
        authService.expireSession();
        return throwError(() => error);
      }

      // 403 = 已登录但没有权限,不代表登录失效,绝不登出;提示用户,原始错误仍交给 RestfulService。
      // body 可能不是 JSON(如 /openapi/*、@RequiresFunctionality 返回 text/plain),所以按类型容错取文案。
      if (error.status == HttpStatusCode.Forbidden) {
        const forbiddenDesc =
          errorBody && Array.isArray(errorBody['statusList'])
            ? (errorBody['statusList'] as Array<StatusInfo>)[0]?.desc
            : typeof errorBody === 'string' && errorBody.length > 0
              ? errorBody
              : undefined;
        messageService.add({
          summary: 'Permission denied',
          severity: 'error',
          detail: forbiddenDesc || 'You do not have permission to perform this action.',
          key: 'general-notification',
        });
        return throwError(() => error);
      }

      // show error message toast on UI
      messageService.add({
        summary: 'Error',
        severity: 'error',
        detail: msg ?? 'Unkown error please contact support@ammall.com',
        key: 'general-notification',
      });
      return throwError(() => new Error(error.message))
    })
  );
};
